import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { windowSize, delay, dbget, dbset } from '../../HOME/utils';
import _ from 'lodash';
import * as f from '../logic';
import { TWISTED, HELPED_KEY } from '../const';
import { Sound } from '../../HOME/Sound';
import { updateStats, showHelp, setToGo, pause, setHelped } from '../REDUX/actions';
import { requestResetStats, requestSurrender } from '../../HOME/REDUX/actions';
import MessageBox from '../../HOME/COMPONENTS/MessageBox';
import Help from './Help';
import Loader from '../../HOME/COMPONENTS/Loader';
import Cell from './Cell';
import ResumeIcon from '../../HOME/SVG/PlayIcon';

const STARS = [[4, 6], [6, 10], [9, 16], [12, 24], [18, 31]];
const FLIP_DURATION = 1000;

class Board extends Component {
  constructor(props) {
    super(props);

    this.state = { flip: false };
    this.cellRefs = [];

    for (let i = 0; i < props.size * props.size; i++) {
      this.cellRefs.push(React.createRef());
    }

    this.boardRef = React.createRef();
  }

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    delay(() => {
      if (this.boardRef.current) {
        this.boardRef.current.addEventListener('animationend', this.onRotationEnd);
      }
    }, 5000);

    dbget(HELPED_KEY, response => {
      if (!response && !this.props.helped) {
        this.props.showHelp(true);
        dbset(HELPED_KEY, true);
        this.props.setHelped();
      }
    });

    this.load();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.boardRef.current.removeEventListener('animationend', this.onRotationEnd);

    this.stopTimer();
    this.props.pause(false);

    if (!this.gameOver()) {
      this.save();
    }

    this.props.requestResetStats(false);
    this.props.requestSurrender(false);
    this.props.showHelp(false);
  }

  load = () => {
    dbget(f.boardKey(this.props), json => {
      if (!json) {
        this.init();
        return;
      }

      this.props.pause(true);

      const { msecs, cells } = this.fromJson(json);
      const starred = _.filter(cells, cell => cell.star);

      _.each(starred, cell => {
        cell.dur = _.random(5, 30);
      });

      let count = starred.length - _.filter(starred, cell => cell.exposed).length;
      this.props.setToGo(count);

      this.cells = cells;
      this.setState({ msecs }, this.updateScoreboard);
    });
  };

  restart = () => {
    this.stopTimer();

    _.each(this.cells, cell => {
      cell.exposed = true;
    });

    this.setState({ flip: _.random(1) ? 'X' : 'Y' });

    delay(() => {
      this.init();

      delay(() => this.setState({ flip: false }), 1);
    }, FLIP_DURATION);
  };

  init = () => {
    this.playSound('dice');
    this.surrender = false;

    this.cells = [];

    const { size } = this.props;
    const range = STARS[size - 3];
    const count = _.random(range[0], range[1]);
    const stars = _.sampleSize([...Array(size * size)].map((_, i) => i), count);

    for (let row = 1; row <= size; row++) {
      for (let col = 1; col <= size; col++) {
        var cell = new Cell();

        cell.row = row;
        cell.col = col;

        const i = this.cells.length;
        cell.star = _.includes(stars, i);
        cell.dur = _.random(5, 30);

        this.cells.push(cell);
      }
    }

    this.props.setToGo(count);
    this.clockwise = !this.clockwise;
    this.setState({ doNotAnimate: false, msecs: 0 }, this.updateScoreboard);
    this.updateToolbar();
  };

  updateToolbar = () => {
    this.props.toolbar.current && this.props.toolbar.current.forceUpdate();
  };

  onRotationEnd = () => {
    if (this.gameOver()) {
      return;
    }

    this.setState({ doNotAnimate: true }, () => {
      delay(() => this.setState({ doNotAnimate: false }), 1);
    });
  };

  cellIndex = (row, col) => {
    return (row - 1) * this.props.size + col - 1;
  };

  playSound = name => {
    Sound(name, this.props.globalOptions.volume);
  };

  startTimer = () => {
    if (this.timer) {
      return;
    }

    if (!this.state.msecs) {
      this.setState({ msecs: 0 });
    }

    this.timer = setInterval(() => {
      if (this.props.paused) {
        return;
      }

      this.setState({ msecs: this.state.msecs + 100 }, this.updateScoreboard);
      this.updateToolbar();
    }, 100);
  };

  stopTimer = () => {
    clearInterval(this.timer);
    this.timer = null;
  };

  updateScoreboard = () => {
    if (this.state.msecs % 1000 === 0) {
      this.save();
      this.props.scoreboard.current.forceUpdate();
    }
  };

  onHit = () => {
    this.playSound('coin1');
    this.startTimer();

    const count = this.props.togo - 1;
    this.props.setToGo(count);

    if (count > 0) {
      return;
    }

    // game over

    this.blocked = true;
    delay(() => (this.blocked = false), 2000);

    this.playSound('draw');
    this.stopTimer();

    _.each(this.cells, cell => {
      cell.exposed = true;
    });

    f.setStats(this.props, this.state.msecs);
  };

  onMiss = () => {
    this.playSound('link1');
    this.startTimer();

    const exposedStars = _.filter(this.cells, cell => cell.star && cell.exposed);

    if (_.isEmpty(exposedStars)) {
      return;
    }

    const count = _.random(1, exposedStars.length);
    const hideCells = _.sampleSize(exposedStars, count);

    _.each(hideCells, cell => {
      cell.exposed = false;
    });

    this.props.setToGo(this.props.togo + count);
  };

  gameOver = () => {
    return this.props.togo === 0;
  };

  handleConfirmSurrender = yes => {
    this.props.pause(false);

    if (yes) {
      f.setStats(this.props, 0, true);
      this.restart();
    }

    delay(() => this.props.requestSurrender(false));
  };

  handleConfirmResetStats = yes => {
    this.props.pause(false);

    if (yes) {
      this.props.updateStats();
    }

    delay(() => this.props.requestResetStats(false));
  };

  handleResume = () => {
    this.props.pause(false);
    this.startTimer();
  };

  save = () => {
    dbset(f.boardKey(this.props), this.toJson());
  };

  toJson = () => {
    const props = ['msecs', 'cells', 'row', 'col', 'star', 'exposed'];

    if (this.props.mode === TWISTED) {
      props.push('clockwise');
      props.push('dur');
    }

    const json = JSON.stringify({ msecs: this.state.msecs, clockwise: this.clockwise, cells: this.cells }, props);

    return json;
  };

  fromJson = json => {
    return JSON.parse(json);
  };

  duration = () => {
    switch (this.props.size) {
      case 3:
        return 16;
      case 4:
        return 18;
      case 5:
        return 21;
      case 6:
        return 25;
      case 7:
      default:
        return 30;
    }
  };

  renderCell = (cell, i, width) => {
    return (
      <span key={i}>
        <Cell ref={this.cellRefs[i]} board={this} mode={this.props.mode} paused={this.props.paused} width={width} cell={cell} />
      </span>
    );
  };

  render() {
    if (!this.cells) {
      return <Loader width={125} />;
    }

    const { mode, size, surrender, resetStats, help } = this.props;
    const { x, y } = windowSize();
    let width = Math.min(x, y - 200) * (mode === TWISTED ? 0.75 : 1) * 0.9;
    width = Math.min(width, 600);
    const cellWidth = (width + size - 1) / size;
    width = `${width}px`;
    const grid = `${_.repeat('auto ', size)}/${_.repeat('auto ', size)}`;
    const clases = `tt-board ${
      mode === TWISTED && !this.state.doNotAnimate && !this.state.flip
        ? this.clockwise
          ? 'mt-twist-clockwise'
          : 'mt-twist-counter-clockwise'
        : ''
    }`;
    const animationDuration = `${this.duration()}s`;
    const style = {
      width,
      height: width,
      grid,
      background: 'rgb(0,0,0,0.1)',
      animationDuration,
      animationIterationCount: 1,
    };
    const containerStyle = {
      transition: `transform ${FLIP_DURATION}ms linear`,
      transform: this.state.flip ? `rotate${this.state.flip}(90deg)` : 'initial',
    };

    return (
      <div className="tt-board-container" style={containerStyle}>
        <div ref={this.boardRef} className={clases} style={style}>
          {_.map(this.cells, (cell, i) => {
            return this.renderCell(cell, i, cellWidth);
          })}
        </div>
        {this.props.paused && !this.props.resetStats && !this.props.surrender && !this.props.help ? (
          <div className="ms-resume fadein-fast" style={{ gridArea: '1/1' }} onClick={this.handleResume}>
            <>
              <span className="ms-game-paused">GAME PAUSED</span>
              <ResumeIcon width="100px" style={{ gridArea: '1/1' }} />
            </>
          </div>
        ) : null}
        {surrender ? <MessageBox message="Give up?" yesNo width={width} onReply={this.handleConfirmSurrender} /> : null}
        {resetStats ? <MessageBox message="Reset stats?" yesNo width={width} onReply={this.handleConfirmResetStats} /> : null}
        {help ? <Help /> : null}
      </div>
    );
  }
}

function mapStateToProps({ mt, common }) {
  return { ...mt, ...common };
}

export default connect(
  mapStateToProps,
  { updateStats, requestSurrender, requestResetStats, showHelp, setToGo, pause, setHelped },
  null,
  { forwardRef: true }
)(Board);
